import React from 'react'
import "./Download_modal.css"
import { Button, Modal } from 'react-bootstrap'

function Download_modal(props) {
    return (
        <>
            <section className='Download_modal_holder'>
                <Modal
                    {...props}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="Download_modal Successfull_Modal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Download
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>
                            Please allow download permissions to download data of Today's Income
                        </p>

                        <div className="btn_holder">
                            <div>
                                <Button className="yes_btn download_btn" onClick={props.onHide}>Yes</Button>
                            </div>

                            <div>
                                <Button className="no_btn download_btn" onClick={props.onHide}>No</Button>
                            </div>
                        </div>
                    </Modal.Body>

                </Modal>
            </section>
        </>
    )
}

export default Download_modal
